'use strict';

var GridDeleteRowButtonDirective = function GridDeleteRowButtonDirective() {
  return {
    restrict: 'E',
    require: '^^rmGridToolbar',
    scope: true,
    template: require('../templates/grid-delete-row-button.html'),
    controller: 'GridDeleteRowButtonController',
    link: function link($scope) {
      $scope.$on('grid:rowSelectionChanged', function (event, selectedRows, gridId, allRows, selectedRowIndexes) {
        $scope.onRowSelection(selectedRows, selectedRowIndexes);
      });
    }
  };
};
GridDeleteRowButtonDirective.$inject = [];
module.exports = GridDeleteRowButtonDirective;